<template>
  <div
    v-if="!cookiesAccepted"
    class="alert bg-white cookie_consent_positioning mb-0 py-3 px-4 shadow-sm"
    data-test-id="cookies_section"
    :style="`bottom: ${footerHeight + footerGap}px`"
  >
    <div class="d-flex flex-column justify-content-between">
      <div>
        <p class="text-dark text-base font-weight-bold mb-2">
          Cookie Consent
        </p>
        <p class="text-dark text-sm mb-3 mb-sm-0">
          We use cookies to personalize and improve your experience on our site
          and to serve you with relevant advertising.
          <span class="d-sm-none">
            For more information, click 'Learn More' to check our data
            collection practices.
          </span>
        </p>
        <p class="text-dark text-sm mb-3 d-none d-sm-block">
          For more information, click 'Learn More' to check our data collection
          practices.
        </p>
      </div>
      <div
        class="d-flex align-items-end justify-content-end"
        style="gap: 10px"
      >
        <router-link
          :to="{ name: 'cookies' }"
          class="btn btn-sm btn-outline-secondary"
          data-test-id="cookies_section_learn_more_btn"
        >
          Learn More
        </router-link>
        <button
          class="btn btn-sm btn-teal"
          data-test-id="cookies_section_got_it_btn"
          @click="acceptCookies"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { isHTMLElement } from "@tinyurldev/tu-ui-vue";

import MixinBreakpoint from "@Mixins/bootstrap/breakpoint";

export default {
  name: "CookiesNotice",

  mixins: [MixinBreakpoint],

  data: () => ({
    footerHeight: 0,
    footerGap: 15,
  }),

  computed: {
    ...mapGetters(["cookiesAccepted"]),
  },

  created() {
    window.addEventListener("resize", this.handleResize);
  },

  mounted() {
    this.handleResize();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    ...mapActions(["acceptCookies"]),

    handleResize() {
      const footer = document.getElementById("footer_section");

      if (!isHTMLElement(footer)) {
        return;
      }

      this.footerHeight = footer.getBoundingClientRect().height;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/position.scss" as position;

.cookie_consent_positioning {
  position: fixed;
  right: 0px;
  width: 100%;
  border-radius: 0;
  z-index: position.$highest-z-index;

  @media (min-width: 576px) {
    right: 30px;
    max-width: 505px;
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
  }
}
</style>
